import { ShareClass } from '../../models/entity';
import { ConditionalDataConfig } from '../../models/configuration/ConditionalDataConfig';
import pivotQueryCollection from './pivotQueryCollection';
import getQueryResults from './getQueryResults';
import { IEntity } from '@kurtosys/ksys-app-template/dist/models/api/search';

export default function getConditionalData(
    entity: ShareClass,
    config: ConditionalDataConfig
) {
    if (config && config.queries) {
        const entityType = entity.type || 'CLSS';
        const queryContext = {
            entityByType: {
                [entityType]: (entity as unknown) as IEntity,
            },
        };
        const queries = pivotQueryCollection(config.queries);
        const results = getQueryResults(queryContext, queries);
        return results;
    }
    return {};
}



// WEBPACK FOOTER //
// ./src/utils/query/getConditionalData.ts